import {map, Observable} from 'rxjs';
import {ActivatedRoute, Params} from '@angular/router';
import { ListQuery } from '@ose/models';

declare module '@angular/router' {
  interface ActivatedRoute {
    getListParams(q: ListQuery): Observable<ListQuery>;
  }
}

ActivatedRoute.prototype.getListParams = function (q: ListQuery): Observable<ListQuery> {
  return this.queryParams.pipe(
    map((param: Params) => {
      q.page = param['page'] || 1;
      q.length = param['length'] || 10;
      q.filter = param['filter'] || undefined;
      q.search = param['search'] || undefined;
      return q;
    })
  );
}



